module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "page-foobar-editor"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('clearfix', {
    attrs: {
      "biggest": true
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 content fb-bg-light"
  }, [_c('loading-spinner')], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 content fb-bg-dark"
  }, [_c('h3', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editTitle),
      expression: "!editTitle"
    }],
    class: _vm.editableClasses,
    on: {
      "click": _vm.startTitleEdit
    }
  }, [_vm._v(_vm._s(_vm.foobar.title))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editTitle),
      expression: "editTitle"
    }]
  }, [_c('label', {
    attrs: {
      "for": "foobar-title"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.field.title')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.foobar.title),
      expression: "foobar.title"
    }],
    staticClass: "full",
    attrs: {
      "id": "foobar-title",
      "type": "text"
    },
    domProps: {
      "value": (_vm.foobar.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.foobar, "title", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": 'sm',
      "variant": 'secondary'
    },
    on: {
      "click": _vm.updateTitle
    }
  }, [_c('icon', {
    attrs: {
      "name": "plus-square"
    }
  }), _vm._v(" \n            " + _vm._s(_vm.$t('message.button.save')) + "\n          ")], 1)], 1)]), _vm._v(" "), _c('clearfix', {
    attrs: {
      "wide": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 content fb-bg-light"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editDescription),
      expression: "!editDescription"
    }],
    staticClass: "data",
    class: _vm.editableClasses,
    domProps: {
      "innerHTML": _vm._s(_vm.foobar.description)
    },
    on: {
      "click": _vm.startDescriptionEdit
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editDescription),
      expression: "editDescription"
    }]
  }, [_c('label', {
    attrs: {
      "for": "foobar-description"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.field.description')))]), _c('br'), _vm._v(" "), _c('quill-editor', {
    attrs: {
      "id": "foobar-description",
      "options": _vm.quillOptionsDescription
    },
    on: {
      "change": _vm.changeDescription
    },
    model: {
      value: (_vm.foobar.description),
      callback: function($$v) {
        _vm.$set(_vm.foobar, "description", $$v)
      },
      expression: "foobar.description"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": 'sm',
      "variant": 'secondary'
    },
    on: {
      "click": _vm.updateDescription
    }
  }, [_c('icon', {
    attrs: {
      "name": "plus-square"
    }
  }), _vm._v(" \n            " + _vm._s(_vm.$t('message.button.save')) + "\n          ")], 1)], 1)]), _vm._v(" "), _c('clearfix', {
    attrs: {
      "wide": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 content fb-bg-light"
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('message.field.md')))]), _vm._v(" "), _c('div', {
    staticClass: "data",
    class: _vm.editableClasses,
    on: {
      "click": _vm.startMarkdownEdit
    }
  }, [_c('vue-markdown', {
    attrs: {
      "source": _vm.foobar.md,
      "lang-prefix": "hljs "
    }
  })], 1), _vm._v(" "), _c('br', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editMarkdown),
      expression: "editMarkdown"
    }]
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editMarkdown),
      expression: "editMarkdown"
    }]
  }, [_c('label', {
    attrs: {
      "for": "foobar-md"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.field.md')))]), _c('br'), _vm._v(" "), _c('b-textarea', {
    staticClass: "full",
    attrs: {
      "rows": 10,
      "id": "foobar-md",
      "placeholder": _vm.$t('message.form.placeholder.md')
    },
    model: {
      value: (_vm.foobar.md),
      callback: function($$v) {
        _vm.$set(_vm.foobar, "md", $$v)
      },
      expression: "foobar.md"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": 'sm',
      "variant": 'secondary'
    },
    on: {
      "click": _vm.updateMarkdown
    }
  }, [_c('icon', {
    attrs: {
      "name": "plus-square"
    }
  }), _vm._v(" \n            " + _vm._s(_vm.$t('message.button.save')) + "\n          ")], 1)], 1)])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading && _vm.foobar.snippets.length === 0),
      expression: "!loading && foobar.snippets.length === 0"
    }],
    staticClass: "row"
  }, [_c('clearfix', {
    attrs: {
      "wide": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 content fb-bg-light"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('message.text.no_snippets_found')) + "\n      ")])], 1), _vm._v(" "), _vm._l((_vm.foobar.snippets), function(snippet) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.loading && _vm.foobar.snippets.length > 0),
        expression: "!loading && foobar.snippets.length > 0"
      }],
      staticClass: "row"
    }, [_c('clearfix', {
      attrs: {
        "wide": true
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12 content fb-bg-light"
    }, [_c('div', {
      staticClass: "foobar-edit-menu single-control",
      attrs: {
        "title": _vm.$t('message.button.delete')
      },
      on: {
        "click": function($event) {
          return _vm.deleteSnippet(snippet.id)
        }
      }
    }, [_c('icon', {
      attrs: {
        "name": "minus-circle"
      }
    })], 1), _vm._v(" "), _c('a', {
      attrs: {
        "name": snippet.id
      }
    }), _vm._v(" "), _c('h3', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.editSnippet[snippet.id].title),
        expression: "!editSnippet[snippet.id].title"
      }],
      staticClass: "data",
      class: _vm.editableClasses,
      on: {
        "click": function($event) {
          return _vm.startSnippetTitleEdit(snippet.id)
        }
      }
    }, [_vm._v(_vm._s(snippet.title))]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.editSnippet[snippet.id].title),
        expression: "editSnippet[snippet.id].title"
      }]
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (snippet.title),
        expression: "snippet.title"
      }],
      staticClass: "full",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (snippet.title)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(snippet, "title", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('b-button', {
      attrs: {
        "size": 'sm',
        "variant": 'secondary'
      },
      on: {
        "click": function($event) {
          return _vm.updateSnippetTitle(snippet.id)
        }
      }
    }, [_c('icon', {
      attrs: {
        "name": "plus-square"
      }
    }), _vm._v(" \n            " + _vm._s(_vm.$t('message.button.save')) + "\n          ")], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')], 1), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.editSnippet[snippet.id].content),
        expression: "!editSnippet[snippet.id].content"
      }],
      staticClass: "data",
      class: _vm.editableClasses,
      on: {
        "click": function($event) {
          return _vm.startSnippetContentEdit(snippet.id)
        }
      }
    }, [_c('pre', {
      directives: [{
        name: "highlightjs",
        rawName: "v-highlightjs",
        value: (snippet.content),
        expression: "snippet.content"
      }]
    }, [_c('code', {
      class: snippet.lang
    })]), _vm._v(" "), _c('div', {
      staticClass: "snippet-id"
    }, [_vm._v(_vm._s(snippet.id))])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.editSnippet[snippet.id].content),
        expression: "editSnippet[snippet.id].content"
      }]
    }, [_c('b-textarea', {
      attrs: {
        "rows": 10
      },
      model: {
        value: (snippet.content),
        callback: function($$v) {
          _vm.$set(snippet, "content", $$v)
        },
        expression: "snippet.content"
      }
    }), _vm._v(" "), _c('br'), _vm._v(" "), _c('b-select', {
      attrs: {
        "options": _vm.langTypes
      },
      model: {
        value: (snippet.lang),
        callback: function($$v) {
          _vm.$set(snippet, "lang", $$v)
        },
        expression: "snippet.lang"
      }
    }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('b-button', {
      attrs: {
        "size": 'sm',
        "variant": 'secondary'
      },
      on: {
        "click": function($event) {
          return _vm.updateSnippetContent(snippet.id)
        }
      }
    }, [_c('icon', {
      attrs: {
        "name": "plus-square"
      }
    }), _vm._v(" \n            " + _vm._s(_vm.$t('message.button.save')) + "\n          ")], 1)], 1)])], 1)
  }), _vm._v(" "), _c('clearfix', {
    attrs: {
      "wide": true
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 content fb-bg-dark"
  }, [_c('b-button', {
    attrs: {
      "size": 'sm',
      "variant": 'primary'
    },
    on: {
      "click": function($event) {
        return _vm.addSnippet()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "plus-square"
    }
  }), _vm._v(" \n          " + _vm._s(_vm.$t('message.button.add_snippet')) + "\n        ")], 1), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": 'sm',
      "variant": 'primary'
    },
    on: {
      "click": function($event) {
        return _vm.editOrder()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "sort"
    }
  }), _vm._v(" \n          " + _vm._s(_vm.$t('message.button.edit_snippet_order')) + "\n        ")], 1)], 1)]), _vm._v(" "), _c('clearfix', {
    attrs: {
      "wide": true
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "row"
  }, [_c('clearfix', {
    attrs: {
      "wide": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 content fb-bg-light"
  }, [_c('div', [_c('span', [_vm._v(_vm._s(_vm.$t('message.title.tags')) + ": ")]), _vm._l((_vm.foobar.tags), function(tag) {
    return _c('b-button', {
      staticClass: "fb-tag",
      attrs: {
        "size": 'sm',
        "variant": 'secondary'
      },
      on: {
        "click": function($event) {
          return _vm.deleteTag(tag)
        }
      }
    }, [_vm._v(_vm._s(tag))])
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newTag),
      expression: "newTag"
    }],
    domProps: {
      "value": (_vm.newTag)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newTag = $event.target.value
      }
    }
  }), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": 'sm',
      "variant": 'secondary'
    },
    on: {
      "click": function($event) {
        return _vm.addTag()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('message.button.add')))])], 2)])], 1), _vm._v(" "), _c('clearfix', {
    attrs: {
      "biggest": true
    }
  }), _vm._v(" "), (_vm.showOrderSnippets) ? _c('modal', {
    on: {
      "close": function($event) {
        _vm.showOrderSnippets = false
      }
    }
  }, [_c('h3', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v(_vm._s(_vm.$t('message.button.edit_snippet_order')))]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('draggable', {
    model: {
      value: (_vm.foobar.snippets),
      callback: function($$v) {
        _vm.$set(_vm.foobar, "snippets", $$v)
      },
      expression: "foobar.snippets"
    }
  }, _vm._l((_vm.foobar.snippets), function(snippet) {
    return _c('div', {
      key: snippet.id
    }, [_vm._v(_vm._s(snippet.title))])
  }), 0)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "buttons"
    },
    slot: "buttons"
  }, [_c('b-button', {
    staticClass: "active-item",
    attrs: {
      "size": 'large',
      "variant": 'secondary'
    },
    on: {
      "click": _vm.saveOrder
    }
  }, [_c('icon', {
    attrs: {
      "name": "check"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('message.button.save')))], 1)], 1)]) : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5eb15194"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/foobar/FoobarEdit.vue
// module id = 1836
// module chunks = 1